import { locales } from '../constants/locale-map';
export const findSupportedLocale = (locale) => {
    if (locales[locale])
        return locale;
    const [base] = locale.split('-');
    const baseLocale = base.toLowerCase();
    const supportLocales = Object.keys(locales).sort();
    if (supportLocales.includes(baseLocale)) {
        return baseLocale;
    }
    const localeMatch = supportLocales.find((l) => l.includes(baseLocale));
    return localeMatch || null;
};
